module.exports = __webpack_public_path__ + "img/arrow-left-icon.eec0a476.svg";